import React, { Component } from "react";
import { Table, Pagination, Col, Row, Button, Select, Input } from "antd";
import moment from "moment";
import { strings } from "../../../helpers";
import AddDoctorContainer from "./AddDoctorContainer";

const { Option } = Select;
const { Search } = Input;
const searchOptions = {
  componentRestrictions: { country: "in" }
};

export default class DoctorsView extends Component {
  render() {
    const {
      details,
      doctor,
      navigateToDoctorDetails,
      getDoctorsListData,
      openFoundDoctorModal,
      toggleAddDoctorModal,
      openAddDoctorModal,
      toggleFoundDoctorModal
    } = this.props;

    const columns = [
      {
        title: "Name",
        align: "left",
        render: record => {
          let fullname = [];
          if (record && record.doctor && record.doctor.first_name !== null) {
            fullname.push(record.doctor.first_name + " ");
          }
          if (record && record.doctor && record.doctor.last_name !== null) {
            fullname.push(record.doctor.last_name);
          }

          return (
            <>{fullname.length > 1 && <div>{fullname[0] + fullname[1]}</div>}</>
          );
        }
      },
      {
        title: "Gender",

        key: "gender",
        align: "left",
        render: record => {
          return (
            <>
              {record && record.doctor && record.doctor.gender && (
                <div>{record.doctor.gender}</div>
              )}
            </>
          );
        }
      },
      {
        title: "Mobile Number",
        dataIndex: "phone_number",
        key: "phone_number",
        align: "left"
      },
      {
        title: "Status",
        dataIndex: "status",
        key: "status",
        align: "left"
      }
    ];
    let source = [];
    if (details && details.metrics) {
      source = details.doctors_list;
    }

    return (
      <div className="content-container">
        <div className="backgroundWhite">
          <Row type="flex" justify="space-between" align="middle">
            <Col span={5} className="heading-domain">
              Doctors
            </Col>
            <Col className="heading-domain  ">
              <Button
                type="primary"
                size="small"
                onClick={toggleAddDoctorModal}
              >
                Add Doctor
              </Button>
            </Col>
          </Row>

          <div className="  kc-block white-bg round-borders-4x">
            <Table
              columns={columns}
              dataSource={source}
              pagination={false}
              onRow={(record, rowIndex) => {
                return {
                  onClick: event => {
                    navigateToDoctorDetails(record);
                  } // click row
                };
              }}
            />
          </div>
        </div>
        <AddDoctorContainer
          openAddDoctorModal={openAddDoctorModal}
          toggleAddDoctorModal={toggleAddDoctorModal}
          getDoctorsListData={getDoctorsListData}
          openFoundDoctorModal={openFoundDoctorModal}
          toggleFoundDoctorModal={toggleFoundDoctorModal}
          clinic={details}
        />
      </div>
    );
  }
}
